import Venue from "@/components/wedding/Venue";

export default function VenuePage() {
  return (
    <div data-testid="venue-page">
      <Venue />
    </div>
  );
}
